import React, { useEffect } from 'react';
import './Toast.css';

export function getApiErrorMessage(error) {
  if (!error) return 'Неизвестная ошибка';
  const d = error.response?.data?.detail;
  if (d == null) return error.message || 'Ошибка сети';
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) {
    return d.map((x) => x.msg || x.loc?.join('.') || JSON.stringify(x)).join('. ') || 'Ошибка валидации';
  }
  if (typeof d === 'object' && d.message) return d.message;
  return String(d);
}

export function ToastList({ toasts, removeToast }) {
  return (
    <div className="toast-list" aria-live="polite">
      {toasts.map((t) => (
        <ToastItem key={t.id} {...t} onClose={() => removeToast(t.id)} />
      ))}
    </div>
  );
}

function ToastItem({ type, text, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 4500);
    return () => clearTimeout(t);
  }, [onClose]);

  return (
    <div className={`toast toast-${type}`} role="alert">
      <span className="toast-text">{text}</span>
      <button type="button" className="toast-close" onClick={onClose} aria-label="Закрыть">
        ×
      </button>
    </div>
  );
}
